"use strict";
module.exports = {
  NODE_ENV: '"production"',
  BACKEND_URI: JSON.stringify(process.env.BACKEND_URI)
};



// WEBPACK FOOTER //
// ./config/prod.env.js